
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/clinician/patients.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import PatientSearchTable from 'vl-common/src/components/PatientSearch/PatientSearchTable';
import Header from '@components/Layouts/Header/Header';
import PageHead from '@components/Layouts/PageHead/PageHead';

const Patients = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <>
      <Header pageType="clinician" pageTitle="Patients" />
      <section className="section-layout">
        <main className="container" id="page-content">
          <PageHead backText="Patients" />
          <div className="section-layout">
            <PatientSearchTable />
          </div>
        </main>
      </section>
    </>
  );
};


export const Route = createFileRoute('/clinician/patients')({ component: Patients });
